/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-support-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadAvgFilesMutationRequest, BulkUploadAvgFilesMutationResponse } from "../models/BulkUploadAvgFiles";
import { buildFormData } from "../.kubb/config";

export function getBulkUploadAvgFilesUrl() {
  const res = { method: 'POST', url: `/avg-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload AVG files
 * {@link /avg-files/bulk-upload}
 */
export async function bulkUploadAvgFiles(data: BulkUploadAvgFilesMutationRequest, config: Partial<RequestConfig<BulkUploadAvgFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, BulkUploadAvgFilesMutationRequest>({ method : "POST", url : getBulkUploadAvgFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}